import React from 'react';

function ChevronUp({
  fill = '#fff',
  width = '752pt',
  height = '752pt',
  viewBox = '0 0 752 752',
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      width={width}
      height={height}
      viewBox={viewBox}
      {...props}
    >
      <path
        d="m577.41 486.93c-7.707 7.7031-20.199 7.7031-27.906 0l-173.51-173.51-173.5 173.51c-7.707 7.7031-20.199 7.7031-27.906 0-7.707-7.707-7.707-20.203 0-27.906l187.46-187.46c7.707-7.707 20.203-7.707 27.906 0l187.46 187.46c7.7031 7.7031 7.7031 20.199 0 27.906z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default ChevronUp;
